import React, { useEffect, useState } from "react";
import { UserModel } from "../../services";
import { Badge, HStack } from "@chakra-ui/react";
import DataTable from "react-data-table-component";
import { CInput } from "../common";
import DeleteUserModal from "./DeleteUserModal";
import DisableUserModal from "./DisableUserModal";

export default function TechniciansTab({ customStyles }) {
  const [users, setUsers] = useState([]);
  const [filteredUsers, setFilteredUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchEmail, setSearchEmail] = useState("");

  const onDelete = (id) => {
    let newData = [...users];
    let foundIndex = users.findIndex((item) => item._id === id);
    if (foundIndex !== -1) {
      newData.splice(foundIndex, 1);
      setUsers(newData);
      newData = [...filteredUsers];
      foundIndex = filteredUsers.findIndex((item) => item._id === id);
      newData.splice(foundIndex, 1);
      setFilteredUsers(newData);
    }
  };

  const onDisable = (id) => {
    let newData = [...users];
    let foundIndex = users.findIndex((item) => item._id === id);
    if (foundIndex !== -1) {
      newData[foundIndex].isDisabled = true;
      setUsers(newData);
      newData = [...filteredUsers];
      foundIndex = filteredUsers.findIndex((item) => item._id === id);
      newData[foundIndex].isDisabled = true;
      setFilteredUsers(newData);
    }
  };

  const columns = [
    {
      name: "Full Name",
      selector: (row) => row.firstName + " " + row.lastName,
    },
    {
      name: "Email",
      selector: (row) => row.email,
    },
    {
      name: "Linked Companies",
      selector: (row) => row.linkedClientsCount,
    },
    {
      name: "Status",
      selector: (row) => (
        <Badge colorScheme={row.isDisabled ? "red" : "green"}>
          {row.isDisabled ? "Disabled" : "Active"}
        </Badge>
      ),
    },
    {
      name: "Action",
      cell: (row) => {
        return (
          <HStack>
            <DeleteUserModal id={row._id} onDelete={onDelete} />
            <DisableUserModal id={row._id} onDisable={onDisable} />
          </HStack>
        );
      },
    },
  ];

  useEffect(() => {
    const fetch = async () => {
      try {
        let res = await UserModel.getAllByRole("technician");
        setUsers(res.data.data);
        setFilteredUsers(res.data.data);
      } catch (error) {
        console.log(error);
      } finally {
        setLoading(false);
      }
    };
    fetch();
  }, []);

  const filterMethods = [
    (item) =>
      item.email.toLowerCase().indexOf(searchEmail?.toLowerCase()) != -1,
  ];

  useEffect(() => {
    if (searchEmail) {
      let searchedUsers = users.filter((item) => {
        for (let i = 0; i < filterMethods.length; i++) {
          if (!filterMethods[i](item)) {
            return false;
          }
        }
        return true;
      });
      setFilteredUsers(searchedUsers);
    } else {
      setFilteredUsers(users);
    }
  }, [searchEmail]);

  return (
    <>
      <HStack
        justifyContent="end"
        alignItems={{ base: "start", md: "center" }}
        flexDirection={{ base: "column", md: "row" }}
        mb={{ base: 0, md: "2" }}
      >
        <HStack
          gap="2"
          minW={{ base: "100%", md: "xs" }}
          flexDirection={{ base: "column", md: "row" }}
        >
          <CInput
            placeholder="Search Email"
            value={searchEmail}
            onChange={(e) => setSearchEmail(e.target.value)}
          />
        </HStack>
      </HStack>
      <DataTable
        columns={columns}
        data={filteredUsers}
        progressPending={loading}
        keyField="_id"
        customStyles={customStyles}
        responsive
        pagination
      />
    </>
  );
}
